const typography = {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
  },
  body1: {
    fontSize: 14,
  },
  overline: {
    fontWeight: 500,
  },
  nav: {
    fontWeight: 500,
    fontSize: 18,
    color: '#4b4b4b',
  },
  navSelected: {
    fontWeight: 600,
    fontSize: 18,
    color: '#1f1f1f',
  },
  title: {
    fontWeight: 600,
    fontSize: 28,
    letterSpacing: '-0.24px',
  },
  titleSmaller: {
    fontWeight: 600,
    fontSize: 24,
  },
  titleMobile: {
    fontWeight: 600,
    fontSize: 18,
    letterSpacing: '-0.24px',
  },
  bannerDescription: {
    fontWeight: 400,
    fontSize: 16,
  },
  bannerMobile: {
    fontWeight: 400,
    fontSize: 12,
  },
  serviceColumnName: {
    fontWeight: 400,
    fontSize: 14,
    color: '#828282',
  },
  columnName: {
    fontWeight: 400,
    fontSize: 14,
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 16,
  },
  flyoutRole: {
    fontWeight: 500,
    fontSize: 14,
    lineeight: 24,
    color: ' #666666',
  },
  fontFamily: `'Inter', sans-serif;`,
};

export default typography;
